import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useMemo, useRef } from "react";
import { useOption } from "../../context/OptionContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useExport } from "../../context/ExportContext";
// import { useStockName } from "../../context/StockNameContext";
import { FaSpinner } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import { CiSearch } from "react-icons/ci";
import useLocalSearch from "../../hooks/useLocalSearch";
import axios from "axios";
import "./OptionChainPage.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const OptionChainPage = () => {
  const [selectedStrike, setSelectedStrike] = useState("");
  const {
    query: localSearch,
    setQuery: setLocalSearch,
    equityResults: localEquityResults,
    loading: localSearchLoading,
    clearResults: clearLocalResults,
  } = useLocalSearch();

  const [activeSecurityId, setActiveSecurityId] = useState("");

  const [selectedIndex, setSelectedIndex] = useState("");
  const [isSaved, setIsSaved] = useState(false); //to check is saved or not

  const [lastUpdated, setLastUpdated] = useState("");
  const [lastFetchType, setLastFetchType] = useState(null);
  const [userTriggered, setUserTriggered] = useState(false);

  const [activeSymbol, setActiveSymbol] = useState("");

  const [symbol, setSymbol] = useState("");
  // const [searchText, setSearchText] = useState("");
  const [selectDropdown, setSelectDropdown] = useState(false);
  const [contract, setContract] = useState("");
  // const [results, setResults] = useState([]);
  const searchSymbol = useParams();
  const atmRef = useRef(null); //new for scroll
  console.log("searchSymbol", searchSymbol);

  const getPlaceholder = () => {
    if (window.matchMedia("(max-width: 600px)").matches) {
      return "Search";
    }
    return "Search Symbol";
  };
  const [placeholder, setPlaceholder] = useState(getPlaceholder());
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };

  const {
    fetchBySymbol,
    loading,
    error,
    pcr,
    meta,
    expiries,
    optionData,
    selectedExpiry,
    setSelectedExpiry,
    setExpiry,
    fetchByIndex,
  } = useOption();
  const { stockName, getNameBySymbol } = useMarketIndicators();
  // const { fetchStock, stockData } = useStockName();
  const { saveOptionChain, downloadOptionCSV, downloadOptionExcel } =
    useExport();

  // useEffect(() => {
  //   if (symbol) {
  //     fetchBySymbol(symbol);
  //     getNameBySymbol(symbol);
  //   }
  // }, [symbol]);
  // useEffect(() => {
  //   if (!symbol) return;

  //   fetchStock(symbol);
  // }, [symbol]);
  // console.log("Stock data from context", stockData);
  const companyName = stockName?.company;
  // const stockCode = stockData?.nse_scrip_code;
  console.log("Stock Name", stockName);

  console.log("expire data", expiries);
  console.log("Option Chain", optionData);
  const totalCallOI = pcr?.totalCallOI;
  const totalPutOI = pcr?.totalPutOI;
  console.log("Call Oi", totalCallOI);
  console.log("Put Oi", totalPutOI);

  console.log("PCR", pcr?.value);
  const underlying = optionData?.data?.last_price ?? 0;

  const oc = optionData?.data?.oc || {};

  const rows = Object.keys(oc)
    .map((strike) => {
      const ce = oc[strike]?.ce;
      const pe = oc[strike]?.pe;

      // -------- CALL --------
      const ceOIChange = ce?.previous_oi != null ? ce.oi - ce.previous_oi : 0;

      const ceOIPercent =
        ce?.previous_oi > 0
          ? +(((ce.oi - ce.previous_oi) / ce.previous_oi) * 100).toFixed(2)
          : 0;

      const ceLtpPercent =
        ce?.previous_close_price > 0
          ? +(
              ((ce.last_price - ce.previous_close_price) /
                ce.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      // -------- PUT --------
      const peOIChange = pe?.previous_oi != null ? pe.oi - pe.previous_oi : 0;

      const peOIPercent =
        pe?.previous_oi > 0
          ? +(((pe.oi - pe.previous_oi) / pe.previous_oi) * 100).toFixed(2)
          : 0;

      const peLtpPercent =
        pe?.previous_close_price > 0
          ? +(
              ((pe.last_price - pe.previous_close_price) /
                pe.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      return {
        strike: Number(strike),

        CE: ce
          ? {
              oi: ce.oi,
              oiChange: ceOIChange,
              oiPercent: ceOIPercent,
              volume: ce.volume,
              iv: ce.implied_volatility,
              ltp: ce.last_price,
              ltpPercent: ceLtpPercent, // ✅ NEW
            }
          : null,

        PE: pe
          ? {
              oi: pe.oi,
              oiChange: peOIChange,
              oiPercent: peOIPercent,
              volume: pe.volume,
              iv: pe.implied_volatility,
              ltp: pe.last_price,
              ltpPercent: peLtpPercent, // ✅ NEW
            }
          : null,
      };
    })
    // ✅ lowest → highest strike (NSE style)
    .sort((a, b) => a.strike - b.strike);
  const totCEVol = rows.reduce((sum, row) => sum + (row.CE?.volume || 0), 0);

  const totPEVol = rows.reduce((sum, row) => sum + (row.PE?.volume || 0), 0);

  const showValue = (value) => {
    return value && value !== 0 ? value : "-";
  };
  const showFormatted = (value, formatter) => {
    if (!value || value === 0) return "-";
    return formatter ? formatter(value) : value;
  };
  const formatNumber = (num) => {
    if (num % 1 !== 0) {
      return num?.toFixed(2);
    }
    return num;
  };

  //strike prices list
  const strikePrices = useMemo(() => {
    const oc = optionData?.data?.oc;
    if (!oc) return [];

    return Object.keys(oc)
      .map(Number)
      .sort((a, b) => a - b);
  }, [optionData]);
  const handleExpiryChange = async (e) => {
    const expiry = e.target.value;

    setSelectedStrike("");
    // setSelectDropdown(false);

    await setExpiry(expiry);
  };
  const handleStrikeChange = (e) => {
    setSelectedStrike(e.target.value);
    setSelectedExpiry("");
    // setSelectDropdown(false);
  };

  const filteredRows = useMemo(() => {
    if (!rows?.length) return [];

    // Strike selected → filter
    if (selectedStrike) {
      return rows.filter((row) => row.strike === Number(selectedStrike));
    }

    // No strike selected → show ALL rows
    return rows;
  }, [rows, selectedStrike]);
  // useEffect(() => {
  //   if (expiries?.length && !selectedExpiry) {
  //     setSelectedExpiry(expiries[0]);
  //   }
  // }, [expiries, selectedExpiry]);

  function calculateMaxPainFromRows(rows, underlying) {
    if (!rows?.length) return null;

    const validRows = rows.filter(
      (r) => (r.CE?.oi || 0) > 0 || (r.PE?.oi || 0) > 0,
    );

    if (!validRows.length) return null;

    const strikes = validRows.map((r) => r.strike);

    let minPain = Infinity;
    let maxPainStrike = null;

    strikes.forEach((strike) => {
      let pain = 0;

      validRows.forEach((row) => {
        const s = row.strike;
        const ceOI = row.CE?.oi || 0;
        const peOI = row.PE?.oi || 0;

        if (strike > s) pain += (strike - s) * ceOI;
        if (strike < s) pain += (s - strike) * peOI;
      });

      if (pain < minPain) {
        minPain = pain;
        maxPainStrike = strike;
      }
    });

    return maxPainStrike;
  }
  const maxPain = calculateMaxPainFromRows(rows, underlying);

  const ceMaxRow = rows.find((r) => r.strike === maxPain)?.CE;
  const peMaxRow = rows.find((r) => r.strike === maxPain)?.PE;
  const premiumRatio =
    ceMaxRow?.ltp > 0 ? (peMaxRow?.ltp / ceMaxRow?.ltp).toFixed(2) : "-";
  // const ceMaxRow = rows.reduce((max, r) => {
  //   if (!r.CE) return max;
  //   return !max || r.CE.oi > max.CE.oi ? r : max;
  // }, null)?.CE;
  // const peMaxRow = rows.reduce((max, r) => {
  //   if (!r.PE) return max;
  //   return !max || r.PE.oi > max.PE.oi ? r : max;
  // }, null)?.PE;

  const builtUpStyles = (signal) => {
    switch (signal) {
      case "LB":
        return { bg: "#d4f7e6", color: "#008A3E" };
      case "SB":
        return { bg: "#ffd4d4", color: "#C53030" };
      case "SC":
        return { bg: "#dce8ff", color: "#0047FF" };
      case "LW":
        return { bg: "#ffeac7", color: "#C68A14" };
      default:
        return { bg: "#f2f2f2", color: "#444" };
    }
  };
  function getBuiltUp(changeInOI, priceChange) {
    if (changeInOI > 0 && priceChange > 0) return "LB"; // Long Built-Up
    if (changeInOI > 0 && priceChange < 0) return "SB"; // Short Built-Up
    if (changeInOI < 0 && priceChange > 0) return "SC"; // Short Covering
    if (changeInOI < 0 && priceChange < 0) return "LW"; // Long Unwinding
    return "-";
  }
  const ceMaxRowBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);

  const peMaxRowBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const builtUpStyleCE = builtUpStyles(ceMaxRowBuiltUp);
  const builtUpStylePE = builtUpStyles(peMaxRowBuiltUp);

  const getPCRSentiment = (pcr) => {
    let sentiment;
    let color; // Text color (dark shade)
    let bgColor; // Background (light shade)

    if (pcr < 0.7) {
      sentiment = "Bearish";
      color = "#C53030"; // Strong red
      bgColor = "#ffd4d4"; // Light red background
    } else if (pcr >= 0.7 && pcr <= 1.0) {
      sentiment = "Neutral";
      color = "#fbbf24";
      bgColor = "#EAEAEA"; // Light gray background
    } else if (pcr > 1.0 && pcr <= 1.3) {
      sentiment = "Bullish";
      color = "#008A3E"; // Dark green
      bgColor = "#d4f7e6"; // Light green background
    } else {
      sentiment = "Overly Bullish (Contrarian Risk)";
      color = "#856404"; // Golden/Brown text
      bgColor = "#FFF3CD"; // Soft yellow background
    }

    return { sentiment, color, bgColor };
  };

  const pcrSentimentColor = getPCRSentiment(pcr?.value);
  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter" && searchText.trim()) {
  //     e.preventDefault();
  //     setSymbol(searchText.trim().toUpperCase());
  //     const val = searchText.trim().toUpperCase();
  //     setActiveSymbol(val);
  //     setLastFetchType("symbol");
  //     setSearchText("");
  //     setSelectedIndex("");
  //     setSelectDropdown(false);
  //   }
  // };
  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();

  //     if (results.length > 0) {
  //       setShowDropdown(true);
  //     }
  //   }

  //   // ESC closes dropdown
  //   if (e.key === "Escape") {
  //     setShowDropdown(false);
  //   }
  // };
  // const handleKeyDown = (e) => {
  //   if (e.key === "Escape") {
  //     setResults([]);
  //   }
  // };
  const handleExportCSV = () => {
    if (!isSaved) {
      alert("⚠ Please save snapshot before exporting");
      return;
    }

    downloadOptionCSV(activeSymbol, selectedExpiry);
  };

  const handleExportExcel = () => {
    if (!isSaved) {
      alert("⚠ Please save snapshot before exporting");
      return;
    }

    downloadOptionExcel(activeSymbol, selectedExpiry);
  };

  const nseIndices = [
    "NIFTY",
    "BANKNIFTY",
    "FINNIFTY",
    "MIDCPNIFTY",
    "NIFTYIT",
    "NIFTY NEXT 50",
    "NIFTY MID100 FREE",
    "NIFTYMCAP50",
    "NIFTYAUTO",
    "NIFTYPHARMA",
    "NIFTYMETAL",
    "NIFTYFMCG",
    "NIFTYREALTY",
    "NIFTYMEDIA",
    "NIFTYENERGY",
  ];
  const handleIndexSelect = (e) => {
    const indexSymbol = e.target.value;
    console.log("Index Symbol", indexSymbol);
    setContract(indexSymbol);
    if (!indexSymbol) return;

    // setSearchText("");
    setSelectedIndex(indexSymbol);
    setActiveSymbol(indexSymbol);
    setLastFetchType("index");
    setSelectedStrike("");
    setSelectDropdown(true);
    fetchByIndex(indexSymbol);
  };
  useEffect(() => {
    if (optionData) {
      setLastUpdated(formatTimestamp());
      setIsSaved(false);
    }
  }, [optionData]);

  const handleRefresh = async () => {
    if (!activeSymbol || !lastFetchType) return;

    if (lastFetchType === "index") {
      await fetchByIndex(activeSymbol);
    } else {
      await fetchBySymbol(activeSymbol);
      await getNameBySymbol(activeSymbol);
      // await fetchStock(activeSymbol);
    }

    setLastUpdated(formatTimestamp());
  };

  const ceMaxOI = rows && Math.max(...rows?.map((item) => item.CE?.oi || 0));

  const peMaxOI = rows && Math.max(...rows.map((item) => item.PE?.oi || 0));
  console.log("CEMAX", ceMaxOI);
  console.log("peMAx", peMaxOI);

  console.log("select dropdown", selectDropdown);
  // console.log("Stock code", stockCode);
  useEffect(() => {
    // Load NIFTY by default on first visit
    if (userTriggered) {
      return;
    }
    if (!activeSymbol && !selectedIndex) {
      const defaultIndex = "NIFTY";

      setContract(defaultIndex);
      setSelectedIndex(defaultIndex);
      setActiveSymbol(defaultIndex);
      setLastFetchType("index");
      setSelectDropdown(true);
      setSelectedStrike("");

      fetchByIndex(defaultIndex);
    }
  }, [activeSymbol, selectedIndex]);
  useEffect(() => {
    // When expiries are fetched for the first time
    if (expiries?.length && !selectedExpiry) {
      const firstExpiry = expiries[0];

      setSelectedExpiry(firstExpiry);
      setExpiry(firstExpiry); // 🔥 VERY IMPORTANT
    }
  }, [expiries, selectedExpiry]);
  //  const getPCRSentiment = (value) => {
  //   if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
  //   if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
  //   return { label: "Bullish", color: "#22c55e" };
  // };

  const getCOIPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };
  // 🔹 Put / Call OI Change color
  const getOIChangeStyle = (value) => {
    if (value > 0) {
      return { background: "#d4f7e6", color: "#008A3E" }; // green
    }
    if (value < 0) {
      return { background: "#ffd4d4", color: "#C53030" }; // red
    }
    return { background: "#f2f2f2", color: "#555" };
  };

  // 🔹 COI PCR color
  // > 1.2  → Bullish
  // 0.8–1.2 → Neutral
  // < 0.8  → Bearish
  const getCOIPCRStyle = (value) => {
    if (value > 1.2) {
      return { background: "#d4f7e6", color: "#008A3E" };
    }
    if (value < 0.8) {
      return { background: "#ffd4d4", color: "#C53030" };
    }
    return { background: "#e8eadf", color: "#444" };
  };

  // 🔹 COI Strength % color (as per NiftyInvest logic)
  const getCOIStrengthStyle = (value) => {
    if (value > 60) {
      return { background: "#d4f7e6", color: "#008A3E" }; // Bullish
    }
    if (value < -60) {
      return { background: "#ffd4d4", color: "#C53030" }; // Bearish
    }
    return { background: "#e8eadf", color: "#444" }; // Neutral
  };
  ///ltp put and call based sentiment
  const getPremiumSentiment = (ratio) => {
    const r = Number(ratio);

    if (r > 1) {
      return { label: "Bearish Sentiment", bg: "#ffd4d4", color: "#C53030" };
    }

    if (r < 0.7) {
      return { label: "Bullish Sentiment", bg: "#d4f7e6", color: "#008A3E" };
    }

    return { label: "Neutral", bg: "#f2f2f2", color: "#555" };
  };
  const prepareRowsForSave = () => {
    // return rows.map((row) => ({
    //   symbol: activeSymbol,
    //   expiry: selectedExpiry,
    //   strike: row.strike,

    //   call_oi: row.CE?.oi ?? null,
    //   call_volume: row.CE?.volume ?? null,
    //   call_iv: row.CE?.iv ?? null,
    //   call_ltp: row.CE?.ltp ?? null,
    //   call_ltp_percent: row.CE?.ltpPercent ?? null,

    //   put_ltp: row.PE?.ltp ?? null,
    //   put_ltp_percent: row.PE?.ltpPercent ?? null,
    //   put_iv: row.PE?.iv ?? null,
    //   put_volume: row.PE?.volume ?? null,
    //   put_oi: row.PE?.oi ?? null,
    // }));
    return rows.map((row) => {
      const ceOI = row.CE?.oi || 0;
      const peOI = row.PE?.oi || 0;

      const rowPCR = ceOI > 0 ? peOI / ceOI : null;
      const premiumRatio = row.CE?.ltp > 0 ? row.PE?.ltp / row.CE?.ltp : null;

      const ceBuiltUp = row.CE
        ? getBuiltUp(row.CE.oiChange, row.CE.ltpPercent)
        : null;

      const peBuiltUp = row.PE
        ? getBuiltUp(row.PE.oiChange, row.PE.ltpPercent)
        : null;

      return {
        symbol: activeSymbol,
        expiry: selectedExpiry,
        strike: row.strike,

        call_oi: row.CE?.oi ?? null,
        call_oi_percent: row.CE?.oiPercent ?? null,
        call_volume: row.CE?.volume ?? null,
        call_iv: row.CE?.iv ?? null,
        call_ltp: row.CE?.ltp ?? null,
        call_ltp_percent: row.CE?.ltpPercent ?? null,
        call_buildup: ceBuiltUp,

        put_ltp: row.PE?.ltp ?? null,
        put_ltp_percent: row.PE?.ltpPercent ?? null,
        put_iv: row.PE?.iv ?? null,
        put_volume: row.PE?.volume ?? null,
        put_oi: row.PE?.oi ?? null,
        put_oi_percent: row.PE?.oiPercent ?? null,
        put_buildup: peBuiltUp,

        row_pcr: rowPCR,
        premium_ratio: premiumRatio,
      };
    });
  };
  console.log("Rows to save:", prepareRowsForSave());

  //handle save for save snapshot button
  const handleSave = async () => {
    try {
      const payload = {
        symbol: activeSymbol,
        expiry: selectedExpiry,
        underlying,
        rows: prepareRowsForSave(),
      };

      await saveOptionChain(payload);

      setIsSaved(true);

      alert("Option chain snapshot saved successfully");
    } catch (err) {
      alert("Save failed");
    }
  };

  const premiumSentiment = getPremiumSentiment(premiumRatio);
  // 🔹 OI Strength % color (TOTAL OI based)
  const getOIStrengthStyle = (value) => {
    if (value > 60) {
      return { background: "#d4f7e6", color: "#008A3E" }; // Bullish
    }
    if (value < -60) {
      return { background: "#ffd4d4", color: "#C53030" }; // Bearish
    }
    return { background: "#e8eadf", color: "#444" }; // Neutral
  };

  const BUILT_UP_META = {
    LB: {
      label: "Long Built-Up",
      signal: "Bullish",
      description: "Open Interest ↑ and Price ↑",
      color: "#008A3E",
      bg: "#D4F7E6",
    },
    SB: {
      label: "Short Built-Up",
      signal: "Bearish",
      description: "Open Interest ↑ and Price ↓",
      color: "#C53030",
      bg: "#FFE1E1",
    },
    SC: {
      label: "Short Covering",
      signal: "Bullish",
      description: "Open Interest ↓ and Price ↑",
      color: "#0047FF",
      bg: "#E6EEFF",
    },
    LW: {
      label: "Long Unwinding",
      signal: "Bearish",
      description: "Open Interest ↓ and Price ↓",
      color: "#C68A14",
      bg: "#FFF3CD",
    },
  };
  const ceBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);
  const peBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const ceBuiltUpMeta = BUILT_UP_META[ceBuiltUp];
  const peBuiltUpMeta = BUILT_UP_META[peBuiltUp];
  const getPCRBg = (value) => {
    if (value < 0.7) return { bg: "#ffd4d4", color: "#C53030" }; // Bearish
    if (value <= 1.0) return { bg: "#f2f2f2", color: "#6b7280" }; // Neutral
    return { bg: "#d4f7e6", color: "#008A3E" }; // Bullish
  };

  const getStrengthBg = (value) => {
    if (value > 60) return { bg: "#d4f7e6", color: "#008A3E" };
    if (value < -60) return { bg: "#ffd4d4", color: "#C53030" };
    return { bg: "#f2f2f2", color: "#6b7280" };
  };
  const getCOIPCRBg = (value) => {
    if (value < 0.7) return { bg: "#ffd4d4", color: "#C53030" };
    if (value <= 1.0) return { bg: "#f2f2f2", color: "#6b7280" };
    return { bg: "#d4f7e6", color: "#008A3E" };
  };

  const getCOIStrengthBg = (value) => {
    if (value > 60) return { bg: "#d4f7e6", color: "#008A3E" };
    if (value < -60) return { bg: "#ffd4d4", color: "#C53030" };
    return { bg: "#f2f2f2", color: "#6b7280" };
  };

  // const handleStockSelect = async (item) => {
  //   const selectedSymbol = item?.underlyingSymbol || item?.symbol;

  //   const selectedSecurityId = item?.securityId || item?.security_id;

  //   if (!selectedSymbol || !selectedSecurityId) {
  //     console.error("Invalid stock search result:", item);
  //     return;
  //   }

  //   const formattedSymbol = selectedSymbol.trim().toUpperCase();

  //   setUserTriggered(true);
  //   setSymbol(formattedSymbol);
  //   setActiveSymbol(formattedSymbol);
  //   setLastFetchType("symbol");
  //   setActiveSecurityId(String(selectedSecurityId));
  //   setSelectedIndex("");
  //   setContract("");
  //   setSelectedStrike("");
  //   setSelectDropdown(false);
  //   setIsSaved(false);

  //   clearLocalResults();

  //   await Promise.all([
  //     fetchBySymbol({
  //       symbol: formattedSymbol,
  //       securityId: selectedSecurityId,
  //     }),
  //     getNameBySymbol(formattedSymbol),
  //   ]);
  // };

  // useEffect(() => {
  //   if (!searchText || searchText.length < 2) {
  //     setResults([]);
  //     return;
  //   }

  //   const fetchSearch = async () => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/api/search-stocks`, {
  //         params: { q: searchText },
  //       });

  //       setResults(res.data || []);
  //     } catch (err) {
  //       console.error("Search failed", err);
  //     }
  //   };

  //   fetchSearch();
  // }, [searchText]);
  // console.log("results:-", results);
  // console.log("Search Result", searchText);

  const handleStockSelect = async (item) => {
    console.log("SELECTED LOCAL SEARCH ITEM:", item);

    const selectedSymbol =
      item?.underlyingSymbol || item?.underlying_symbol || item?.symbol;

    const selectedSecurityId =
      item?.securityId ||
      item?.security_id ||
      item?.underlyingId ||
      item?.underlying_id;

    console.log("RESOLVED SYMBOL:", selectedSymbol);
    console.log("RESOLVED SECURITY ID:", selectedSecurityId);

    if (!selectedSymbol) {
      console.error("Symbol is missing:", item);
      return;
    }

    if (!selectedSecurityId) {
      console.error("Security ID is missing:", item);
      return;
    }

    const formattedSymbol = selectedSymbol.trim().toUpperCase();
    const formattedSecurityId = Number(selectedSecurityId);

    setUserTriggered(true);
    setSymbol(formattedSymbol);
    setActiveSymbol(formattedSymbol);
    setActiveSecurityId(formattedSecurityId);
    setLastFetchType("symbol");

    setSelectedIndex("");
    setContract("");
    setSelectedStrike("");
    setSelectDropdown(false);
    setIsSaved(false);

    clearLocalResults();

    await Promise.all([
      fetchBySymbol({
        symbol: formattedSymbol,
        securityId: formattedSecurityId,
      }),
      getNameBySymbol(formattedSymbol),
    ]);
  };
  console.log("Symbol", symbol);
  const navigate = useNavigate();

  const stickyHeader = {
    position: "sticky",
    top: 0,

    color: "white",
    zIndex: 5,
  };
  const atmStrike = useMemo(() => {
    if (!rows?.length || !underlying) return null;

    return rows.reduce((closest, row) => {
      const diff = Math.abs(row.strike - underlying);

      if (!closest || diff < Math.abs(closest.strike - underlying)) {
        return row;
      }

      return closest;
    }, null)?.strike;
  }, [rows, underlying]);
  useEffect(() => {
    if (!atmRef.current) return;

    // Small delay to let the DOM render the table rows
    const timer = setTimeout(() => {
      atmRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }, 300);

    return () => clearTimeout(timer);
  }, [atmStrike, selectedExpiry, activeSymbol]);
  const atmRow = rows.find((r) => r.strike === atmStrike);
  const atmPremiumRatio =
    atmRow?.CE?.ltp > 0 ? (atmRow?.PE?.ltp / atmRow?.CE?.ltp).toFixed(2) : "-";
  const atmPremiumSentiment = getPremiumSentiment(atmPremiumRatio);

  return (
    <div>
      <div className="back-export-files">
        <div className="back-btn">
          <button
            className="rec-btn trendpro-back-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button className="rec-btn trendpro-back-btn" onClick={handleSave}>
            Save Snapshot
          </button>

          <button
            className="rec-btn trendpro-back-btn"
            onClick={handleExportCSV}
            // disabled={!isSaved}
          >
            Export CSV
          </button>

          <button
            className="rec-btn trendpro-back-btn"
            onClick={handleExportExcel}
            // disabled={!isSaved}
          >
            Export Excel
          </button>
        </div>
      </div>

      <div className="option-chain">
        <div className="option-menu nse-layout">
          <div className="option-chain-head">
            <div className="select-option dropdown">
              <label>Contracts</label>
              <select onChange={handleIndexSelect} value={selectedIndex}>
                <option value="">Select</option>
                {nseIndices.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <span className="select-span">OR</span>

            {/* <div className="search-option dropdown">
              <label>Search Symbol</label>

              <div
                className="search-option-input"
                style={{
                  borderRadius: "12px",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 10px",

                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                }}
              >
                <input
                  type="text"
                  placeholder={placeholder}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setResults([]);
                  }}
                  onKeyDown={handleKeyDown}
                  className="search-option-chain"
                  style={{
                    padding: "14px 15px",

                    borderRadius: "20px",
                    border: "none",
                    outline: "none",
                  }}
                />
                <span className="search-span" style={{ cursor: "pointer" }}>
                  <CiSearch />
                </span>
                {results.length > 0 && (
                  <div className="search-optionpage-dropdown">
                    {results.map((item) => (
                      <div
                        key={item.id}
                        className="search-option-dropdown-item"
                        onClick={() => {
                          setSymbol(item.symbol);
                          setActiveSymbol(item.symbol);
                          setLastFetchType("symbol");
                          setUserTriggered(true);
                          // UI cleanup
                          setSearchText("");
                          setResults([]);
                          setSelectedIndex("");
                          setSelectDropdown(false);
                        }}
                      >
                        <div className="dropdown-symbol">{item.symbol}</div>
                        <div className="dropdown-company">{item.company}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div> */}

            <div className="search-option dropdown">
              <label>Search Symbol</label>

              <div
                className="search-option-input"
                style={{
                  borderRadius: "12px",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 10px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                  position: "relative",
                }}
              >
                <input
                  type="text"
                  placeholder={placeholder}
                  value={localSearch}
                  onChange={(e) => setLocalSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      clearLocalResults();
                    }
                  }}
                  className="search-option-chain"
                  style={{
                    padding: "14px 15px",
                    borderRadius: "20px",
                    border: "none",
                    outline: "none",
                  }}
                />

                <span className="search-span" style={{ cursor: "pointer" }}>
                  <CiSearch />
                </span>

                {localSearchLoading && (
                  <span style={{ fontSize: "12px", marginLeft: "8px" }}>
                    Searching...
                  </span>
                )}

                {localEquityResults?.length > 0 && (
                  <div className="search-optionpage-dropdown">
                    <div className="search-section-title">Stocks</div>

                    {localEquityResults.map((item, index) => {
                      const itemSymbol = item?.underlyingSymbol || item?.symbol;

                      const itemSecurityId =
                        item?.securityId || item?.security_id;

                      return (
                        <div
                          key={
                            item?.id ||
                            itemSecurityId ||
                            `${itemSymbol}-${index}`
                          }
                          className="search-option-dropdown-item"
                          onClick={() => handleStockSelect(item)}
                        >
                          <div className="dropdown-symbol">{itemSymbol}</div>

                          <div className="dropdown-company">
                            {item?.displayName ||
                              item?.company ||
                              item?.companyName}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="option-chain-head">
            <div className="select-option dropdown">
              <label>Expiry Dates</label>
              <select
                value={selectedExpiry || ""}
                onChange={handleExpiryChange} // ✅ SAME HANDLER
              >
                {expiries?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <span className="select-span">OR</span>

            <div className="select-option dropdown">
              <label>Strike</label>
              <select
                value={selectedStrike || ""}
                onChange={handleStrikeChange}
              >
                <option value="">Select</option>
                <option value="">Default</option>
                {strikePrices?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            // color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )}
      {/* {!loading && error && (
        <div
          style={{
            marginTop: "20px",
            padding: "14px",
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          ❌ {error}
        </div>
      )} */}
      {error && !loading && !optionData && (
        <div className="option-error">{error}</div>
      )}

      {!loading &&
        optionData &&
        Object.keys(optionData?.data?.oc || {}).length > 0 && (
          <div>
            <div
              className="last-updated-head"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {lastUpdated && <span>As on {lastUpdated}</span>}

              <FiRefreshCw
                size={16}
                onClick={handleRefresh}
                style={{
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
                onMouseOut={(e) => (e.target.style.color = "#6b7280")}
              />
            </div>

            <div
              className="grid-1"
              style={{
                // display: "flex",
                // flexDirection: "column",
                gap: "10px",
                textAlign: "left",
                marginTop: "10px",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
              }}
            >
              <p>
                {!selectDropdown && <p>{}</p>}
                <span>
                  {" "}
                  {selectDropdown ? "Contract" : companyName}
                  <span className="stock-tag" style={{ width: "max-content" }}>
                    {selectDropdown ? contract : symbol}
                  </span>
                </span>
              </p>
              <p>
                LTP
                <span
                  style={{
                    fontWeight: "700",
                    // color: "#00b3ff",
                    backgroundColor: " #e6f0ff",
                    color: " #0062ff",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    width: "max-content",
                  }}
                >
                  {" "}
                  {underlying}
                </span>
              </p>

              <p>
                Max Pain{" "}
                <span
                  style={{
                    fontWeight: "700",
                    color: "#008A3E",
                    background: "rgb(212, 247, 230)",

                    padding: "4px 10px",
                    borderRadius: "8px",
                    width: "max-content",
                  }}
                >
                  {maxPain}
                </span>
              </p>
              <p>
                ATM Put/Call Premium Ratio
                <span
                  style={{
                    background: atmPremiumSentiment.bg,
                    color: atmPremiumSentiment.color,
                    padding: "4px 10px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    width: "max-content",
                  }}
                >
                  {atmPremiumRatio} ({atmPremiumSentiment.label})
                </span>
              </p>
              <p>
                PCR Signal{" "}
                <strong
                  style={{
                    color: pcrSentimentColor.color,
                    background: pcrSentimentColor.bgColor,
                    width: "max-content",
                    padding: "4px 10px",
                    borderRadius: "8px",
                  }}
                >
                  {" "}
                  {pcrSentimentColor.sentiment}
                </strong>
              </p>
            </div>

            <div className="pcr-grid pcr-grid-layout">
              <div className="ce-pe">
                <div className="ce-pe1">
                  <div>
                    <h3>Ltp ({maxPain} CE)</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          ceMaxRow?.ltpPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                        color:
                          ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {ceMaxRow?.ltp ?? "-"}{" "}
                      {ceMaxRow?.ltpPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {ceMaxRow?.ltpPercent !== undefined
                          ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>

                  <div className="sub-grid">
                    <h3>Open Interest</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          ceMaxRow?.oiPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                        color: ceMaxRow?.oiPercent > 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                      {ceMaxRow?.oiPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {ceMaxRow?.oiPercent !== undefined
                          ? ceMaxRow.oiPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>

                  <div className="sub-grid">
                    <h3>Built Up</h3>

                    <div
                      className="ce-pe2 builtup-box"
                      style={{
                        backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                        color: ceBuiltUpMeta?.color || "#444",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      {ceBuiltUp}

                      {/* 🔹 Hover tooltip */}
                      {ceBuiltUpMeta && (
                        <div className="builtup-tooltip">
                          <strong>{ceBuiltUpMeta.label}</strong>
                          <div>{ceBuiltUpMeta.description}</div>
                          <div>
                            Signal:{" "}
                            <span
                              style={{
                                fontWeight: "bold",
                                color:
                                  ceBuiltUpMeta.signal === "Bullish"
                                    ? "#008A3E"
                                    : "#C53030",
                              }}
                            >
                              {ceBuiltUpMeta.signal}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="ce-pe1">
                  <div>
                    <h3>Ltp ({maxPain} PE)</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          peMaxRow?.ltpPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                        color: peMaxRow?.ltpPercent > 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {peMaxRow?.ltp ?? "-"}{" "}
                      {peMaxRow?.ltpPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {peMaxRow?.ltpPercent !== undefined
                          ? peMaxRow.ltpPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>

                  {/* OI box */}
                  <div className="sub-grid">
                    <h3>Open Interest</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          peMaxRow?.oiPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                        color: peMaxRow?.oiPercent > 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {formatNumber(peMaxRow?.oi) ?? "-"}
                      {peMaxRow?.oiPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {peMaxRow?.oiPercent !== undefined
                          ? peMaxRow.oiPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>
                  {/* <div className="sub-grid">
                  <h3>Built Up</h3>
                  <div
                    className="ce-pe2"
                    style={{
                      backgroundColor: builtUpStylePE.bg,
                      color: builtUpStylePE.color,
                    }}
                  >
                    {peMaxRowBuiltUp}
                  </div>
                </div> */}
                  <div className="sub-grid">
                    <h3>Built Up</h3>

                    <div
                      className="ce-pe2 builtup-box"
                      style={{
                        backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                        color: peBuiltUpMeta?.color || "#444",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      {peBuiltUp}

                      {peBuiltUpMeta && (
                        <div className="builtup-tooltip">
                          <strong>{peBuiltUpMeta.label}</strong>
                          <div>{peBuiltUpMeta.description}</div>
                          <div>
                            Signal:{" "}
                            <span
                              style={{
                                fontWeight: "bold",
                                color:
                                  peBuiltUpMeta.signal === "Bullish"
                                    ? "#008A3E"
                                    : "#C53030",
                              }}
                            >
                              {peBuiltUpMeta.signal}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="grid  built-up-grid built-mobile"
                style={{
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                }}
              >
                <div className="pcr-box">
                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Put OI</div>
                    <div
                      className="value red"
                      style={{
                        background: "#ffd4d4",
                        color: "#C53030",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr.totalPutOI.toLocaleString()}
                    </div>
                  </div>

                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Call OI</div>
                    <div
                      className="value green"
                      style={{
                        background: "#d4f7e6",
                        color: "#008A3E",

                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr.totalCallOI.toLocaleString()}
                    </div>
                  </div>

                  {/* PCR */}
                  <div className="pcr-inner-box">
                    <div className="pcr-label">PCR</div>

                    {(() => {
                      const sentiment = getPCRSentiment(pcr.pcr);
                      const { bg, color } = getPCRBg(pcr?.value);
                      return (
                        <div
                          className="value"
                          style={{
                            background: bg,
                            color,

                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.value}

                          <span
                            className="sentiment-hover"
                            style={{ color: sentiment.color }}
                          >
                            {sentiment.label}
                          </span>
                        </div>
                      );
                    })()}
                  </div>

                  <div className="pcr-inner-box">
                    <div className="pcr-label">OI Strength%</div>

                    {(() => {
                      const sentiment = getPCRSentiment(pcr.pcr);
                      const { background, color } = getOIStrengthStyle(
                        pcr?.oiStrength,
                      );
                      return (
                        <div
                          className="value"
                          style={{
                            background,
                            color,

                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.oiStrength}%
                          {/* 
                          <span
                            className="sentiment-hover"
                            style={{ color: sentiment.color }}
                          >
                            {sentiment.label}
                          </span> */}
                        </div>
                      );
                    })()}
                  </div>
                </div>

                <div className="pcr-box">
                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Put OI Chg</div>
                    <div
                      className="value red"
                      style={{
                        background: "#ffd4d4",
                        color: "#C53030",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr?.putOIChange?.toLocaleString()}
                    </div>
                  </div>

                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Call OI Chg</div>
                    <div
                      className="value green"
                      style={{
                        background: "#d4f7e6",
                        color: "#008A3E",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr?.callOIChange?.toLocaleString()}
                    </div>
                  </div>

                  <div className="pcr-inner-box">
                    <div className="pcr-label">COI PCR</div>

                    {(() => {
                      const sentiment = getCOIPCRSentiment(pcr?.coiPCR);
                      const { background, color } = getCOIPCRStyle(pcr?.coiPCR);
                      return (
                        <div
                          className="value"
                          // style={getCOIPCRStyle(pcr?.coiPCR)}
                          style={{
                            background,
                            color,
                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.coiPCR}
                          {/* 
                          <span
                            className="sentiment-hover"
                            style={{ color: getCOIPCRStyle(pcr?.coiPCR).color }}
                          >
                            {sentiment.label}
                          </span> */}
                        </div>
                      );
                    })()}
                  </div>

                  <div className="pcr-inner-box">
                    <div className="pcr-label">COI Strength %</div>
                    {(() => {
                      const { background, color } = getCOIStrengthStyle(
                        pcr?.coiStrength,
                      );

                      return (
                        <div
                          className="value"
                          // style={getCOIPCRStyle(pcr?.coiPCR)}
                          style={{
                            background,
                            color,
                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.coiStrength}%
                          {/* 
                          <span
                            className="sentiment-hover"
                            style={{ color: getCOIPCRStyle(pcr?.coiPCR).color }}
                          >
                            {sentiment.label}
                          </span> */}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>

              <div className="grid call-grid">
                <div className="sub-grid">
                  <h3>Ltp ({maxPain} CE)</h3>

                  <div
                    className="sub-grid-div"
                    style={{
                      background:
                        ceMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {ceMaxRow?.ltp ?? "-"}{" "}
                    {ceMaxRow?.ltpPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {ceMaxRow?.ltpPercent !== undefined
                        ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3>Open Interest</h3>
                  <div
                    className="sub-grid-div"
                    style={{
                      background:
                        ceMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: ceMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                    {ceMaxRow?.oiPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {ceMaxRow?.oiPercent !== undefined
                        ? ceMaxRow.oiPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>

                {/* <div className="sub-grid">
                <h3>Built Up</h3>
                <div
                  style={{
                    backgroundColor: builtUpStyleCE.bg,
                    color: builtUpStyleCE.color,
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {ceMaxRowBuiltUp}
                </div>
              </div> */}
                <div className="sub-grid">
                  <h3>Built Up</h3>

                  <div
                    className="ce-pe2 builtup-box"
                    style={{
                      backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                      color: ceBuiltUpMeta?.color || "#444",
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    {ceBuiltUp}

                    {/* 🔹 Hover tooltip */}
                    {ceBuiltUpMeta && (
                      <div className="builtup-tooltip">
                        <strong>{ceBuiltUpMeta.label}</strong>
                        <div>{ceBuiltUpMeta.description}</div>
                        <div>
                          Signal:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color:
                                ceBuiltUpMeta.signal === "Bullish"
                                  ? "#008A3E"
                                  : "#C53030",
                            }}
                          >
                            {ceBuiltUpMeta.signal}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid call-grid">
                <div className="sub-grid">
                  <h3>Ltp ({maxPain} PE)</h3>

                  <div
                    className="sub-grid-div"
                    style={{
                      background:
                        peMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: peMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {peMaxRow?.ltp ?? "-"}{" "}
                    {peMaxRow?.ltpPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.ltpPercent !== undefined
                        ? peMaxRow.ltpPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3>Open Interest</h3>
                  <div
                    className="sub-grid-div"
                    style={{
                      background:
                        peMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: peMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {formatNumber(peMaxRow?.oi) ?? "-"}
                    {peMaxRow?.oiPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.oiPercent !== undefined
                        ? peMaxRow.oiPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3>Built Up</h3>

                  <div
                    className="ce-pe2 builtup-box"
                    style={{
                      backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                      color: peBuiltUpMeta?.color || "#444",
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    {peBuiltUp}

                    {peBuiltUpMeta && (
                      <div className="builtup-tooltip">
                        <strong>{peBuiltUpMeta.label}</strong>
                        <div>{peBuiltUpMeta.description}</div>
                        <div>
                          Signal:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color:
                                peBuiltUpMeta.signal === "Bullish"
                                  ? "#008A3E"
                                  : "#C53030",
                            }}
                          >
                            {peBuiltUpMeta.signal}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid call-grid">
                {/* PUT OI */}
                <div className="sub-grid">
                  <h3>Put OI</h3>

                  <div
                    className="sub-grid-div"
                    style={{
                      background: "#ffd4d4",
                      color: "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.totalPutOI?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* CALL OI */}
                <div className="sub-grid">
                  <h3>Call OI</h3>

                  <div
                    className="sub-grid-div"
                    style={{
                      background: "#d4f7e6",
                      color: "#008A3E",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.totalCallOI?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* PCR */}
                <div className="sub-grid">
                  <h3>PCR</h3>

                  {(() => {
                    const { bg, color } = getPCRBg(pcr?.value);
                    return (
                      <div
                        className="sub-grid-div"
                        style={{
                          background: bg,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.value ?? "-"}
                      </div>
                    );
                  })()}
                </div>

                {/* OI STRENGTH % */}
                <div className="sub-grid">
                  <h3>OI Strength %</h3>

                  {(() => {
                    const { background, color } = getOIStrengthStyle(
                      pcr?.oiStrength,
                    );
                    return (
                      <div
                        className="sub-grid-div"
                        style={{
                          background,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.oiStrength ?? 0} %
                      </div>
                    );
                  })()}
                </div>
              </div>
              <div className="grid call-grid">
                {/* PUT OI CHANGE */}
                <div className="sub-grid">
                  <h3>Put OI Chg</h3>

                  <div
                    className="sub-grid-div"
                    style={{
                      background: pcr?.putOIChange >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: pcr?.putOIChange >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.putOIChange?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* CALL OI CHANGE */}
                <div className="sub-grid">
                  <h3>Call OI Chg</h3>

                  <div
                    className="sub-grid-div"
                    style={{
                      background:
                        pcr?.callOIChange >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: pcr?.callOIChange >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.callOIChange?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* COI PCR */}
                <div className="sub-grid">
                  <h3>COI PCR</h3>

                  {(() => {
                    // const { bg, color } = getCOIPCRBg(pcr?.coiPCR);
                    const { background, color } = getCOIPCRStyle(pcr?.coiPCR);
                    return (
                      <div
                        className="sub-grid-div"
                        style={{
                          background,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.coiPCR ?? "-"}
                      </div>
                    );
                  })()}
                </div>

                {/* COI STRENGTH % */}
                <div className="sub-grid">
                  <h3>COI Strength %</h3>

                  {(() => {
                    const { background, color } = getCOIStrengthStyle(
                      pcr?.coiStrength,
                    );
                    return (
                      <div
                        className="sub-grid-div"
                        style={{
                          background,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          Radius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          borderRadius: "8px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.coiStrength ?? 0} %
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>

            <div
              className="stock-table-container  option-chain-table"
              style={{
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",

                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "600px",
                position: "relative",
                display: "block",
              }}
            >
              <table
                className="stock-table oc-table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "20px auto",
                  maxHeight: "600px",
                  overflowX: "auto",
                  overflowY: "auto",
                  position: "relative",
                }}
              >
                <thead style={{ position: "sticky", top: 0, zIndex: 5 }}>
                  <tr>
                    <th style={stickyHeader}>CALL OI</th>
                    <th style={stickyHeader}>CALL OI %</th>
                    <th style={stickyHeader}>CALL VOL</th>
                    <th style={stickyHeader}>CALL IV</th>
                    <th style={stickyHeader}>CALL LTP</th>
                    <th style={stickyHeader}>CALL LTP %</th>
                    <th style={stickyHeader}>BUILT UP</th>

                    <th
                      style={{
                        ...stickyHeader,
                        background: "#f3f3f3",
                        color: "black",
                      }}
                    >
                      STRIKE
                    </th>
                    <th
                      style={{
                        ...stickyHeader,
                        background: "#f3f3f3",
                        color: "black",
                      }}
                    >
                      PCR
                    </th>
                    <th
                      style={{
                        ...stickyHeader,
                        background: "#f3f3f3",
                        color: "black",
                      }}
                    >
                      PUT/CALL Premium Ratio
                    </th>
                    <th style={stickyHeader}>BUILT UP</th>

                    <th style={stickyHeader}>PUT LTP</th>
                    <th style={stickyHeader}>PUT LTP %</th>
                    <th style={stickyHeader}>PUT IV</th>
                    <th style={stickyHeader}>PUT VOL</th>
                    <th style={stickyHeader}>PUT OI %</th>
                    <th style={stickyHeader}>PUT OI</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows?.map((row, idx) => {
                    const ceOI = row.CE?.oi || 0;
                    const peOI = row.PE?.oi || 0;
                    const rowPCR = ceOI > 0 ? (peOI / ceOI).toFixed(2) : "-";
                    const rowPCB =
                      row?.CE?.ltp > 0
                        ? (row?.PE?.ltp / row?.CE?.ltp).toFixed(2)
                        : "-";

                    const ceBuiltUp = row.CE
                      ? getBuiltUp(row.CE.oiChange, row.CE.ltpPercent)
                      : "-";

                    const peBuiltUp = row.PE
                      ? getBuiltUp(row.PE.oiChange, row.PE.ltpPercent)
                      : "-";

                    return (
                      <tr
                        key={idx}
                        ref={row.strike === atmStrike ? atmRef : null}
                        style={{
                          backgroundColor:
                            row.strike === atmStrike
                              ? "rgba(37, 99, 235, 0.08)" // subtle blue highlight for ATM
                              : "transparent",
                        }}
                      >
                        {/* ===== CALL ===== */}
                        <td
                          style={{
                            backgroundColor:
                              row?.CE?.oi === ceMaxOI
                                ? "#2fd18a"
                                : "transparent",
                            fontWeight:
                              row?.CE?.oi === ceMaxOI ? "bold" : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {row.CE?.oi || "-"}
                        </td>

                        <td
                          style={{
                            color:
                              row.CE?.oiPercent > 0
                                ? "#2fd18a"
                                : row.CE?.oiPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.CE?.oiPercent ? `${row.CE.oiPercent}%` : "-"}
                        </td>

                        <td>{row.CE?.volume || "-"}</td>
                        <td>{row.CE?.iv ? row.CE.iv.toFixed(2) : "-"}</td>
                        <td>{row.CE?.ltp || "-"}</td>

                        <td
                          style={{
                            color:
                              row.CE?.ltpPercent > 0
                                ? "#2fd18a"
                                : row.CE?.ltpPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.CE?.ltpPercent ? `${row.CE.ltpPercent}%` : "-"}
                        </td>
                        <td style={{ color: builtUpStyles(ceBuiltUp).color }}>
                          {ceBuiltUp}
                        </td>

                        {/* ===== STRIKE ===== */}
                        <td
                          style={{
                            fontWeight: 700,
                            color: row?.strike === maxPain ? "white" : "black",
                            backgroundColor:
                              row?.strike === maxPain ? "#2563eb" : "",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {row.strike}
                        </td>

                        {/* ===== PCR ===== */}
                        <td style={{ fontWeight: 700 }}>{rowPCR}</td>
                        <td
                          style={{
                            fontWeight: 700,
                            color: getPremiumSentiment(rowPCB).color,
                          }}
                        >
                          {rowPCB}
                        </td>
                        <td style={{ color: builtUpStyles(peBuiltUp).color }}>
                          {peBuiltUp}
                        </td>

                        {/* ===== PUT ===== */}
                        <td>{row.PE?.ltp || "-"}</td>

                        <td
                          style={{
                            color:
                              row.PE?.ltpPercent > 0
                                ? "#2fd18a"
                                : row.PE?.ltpPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.PE?.ltpPercent ? `${row.PE.ltpPercent}%` : "-"}
                        </td>

                        <td>{row.PE?.iv ? row.PE.iv.toFixed(2) : "-"}</td>
                        <td>{row.PE?.volume || "-"}</td>

                        <td
                          style={{
                            color:
                              row.PE?.oiPercent > 0
                                ? "#2fd18a"
                                : row.PE?.oiPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.PE?.oiPercent ? `${row.PE.oiPercent}%` : "-"}
                        </td>

                        <td
                          style={{
                            backgroundColor:
                              row?.PE?.oi === peMaxOI
                                ? "#ff4d4d"
                                : "transparent",
                            fontWeight:
                              row?.PE?.oi === peMaxOI ? "bold" : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {row.PE?.oi || "-"}
                        </td>
                      </tr>
                    );
                  })}

                  {/* ✅ TOTAL ROW (OUTSIDE map) */}
                  <tr className="final-row-bottom">
                    <td>{formatNumber(totalCallOI)}</td>
                    <td></td>
                    <td>{totCEVol || "-"}</td>
                    <td></td>
                    <td></td>
                    <td></td>

                    <td style={{ fontWeight: 700 }}>Total</td>
                    <td
                      style={{
                        color:
                          totalPutOI / totalCallOI < 0.5
                            ? "#ff4d4d"
                            : totalPutOI / totalCallOI > 1.5
                              ? "#2fd18a"
                              : "#e6e6e6",
                        fontWeight: "bold",
                        padding: "6px",
                        textAlign: "center",
                      }}
                    >
                      {(totalPutOI / totalCallOI).toFixed(2)}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{totPEVol || "-"}</td>
                    <td></td>
                    <td>{formatNumber(totalPutOI)}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
    </div>
  );
};

export default OptionChainPage;
